// @flow
import * as React from 'react'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

export function ArticleList () {
  const publisherDomain = parseHostname().publicationDomain

  return (
    <aside className='ui segment' style={{ backgroundColor: '#f9d095' }}>
      <h4 className='ui infographic tiny header'>
        Weitere Storys zum Hotelrating:
      </h4>
      <div className='ui icon very relaxed infographic attached link list'>
        <a
          href={`https://www.${publisherDomain}/27899229`}
          target='_parent'
          className='item'
        >
          <i className='external icon bottom aligned' />
          <div className='content'>
            Waldhotel Doldenhorn{' '}
            <div className='header'>Dank Spa ein Ganzjahresbetrieb</div>
          </div>
        </a>
        <a
          href={`https://www.${publisherDomain}/12703630`}
          target='_parent'
          className='item'
        >
          <i className='external icon bottom aligned' />
          <div className='content'>
            Tschuggen Hotel Group{' '}
            <div className='header'>Ein Märchen geht weiter</div>
          </div>
        </a>
        <a
          href={`https://www.${publisherDomain}/20080054`}
          target='_parent'
          className='item'
        >
          <i className='external icon bottom aligned' />
          <div className='content'>
            <div className='header'>Das Wunder von Saas-Fee</div>
          </div>
        </a>
      </div>
    </aside>
  )
}



// WEBPACK FOOTER //
// ./src/components/articleList/index.js